import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useMsal } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';
import { useAdmin } from '../context/AdminContext';
import { formatFecha } from '../utils/fecha';
import { API } from '../config/api';
import ModalGasto from '../components/ModalGasto';

const MESES = ['', 'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
const inputStyle = { padding: '8px 12px', border: '1px solid #e0e0e0', borderRadius: '8px', fontSize: '13px', outline: 'none', boxSizing: 'border-box', fontFamily: 'Segoe UI, sans-serif', background: '#fff' };
const fmt = (n) => (n == null || isNaN(n)) ? '—' : Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const simbolo = (m) => m === 'Dólares' ? '$' : m === 'Euros' ? '€' : '₡';

const campoVer = (label, valor) => (
  <div>
    <div style={{ fontSize: '10px', color: '#aaa', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '3px' }}>{label}</div>
    <div style={{ fontSize: '13px', color: valor ? '#012E40' : '#ccc', fontWeight: valor ? '500' : '400' }}>{valor || '—'}</div>
  </div>
);

const badgeEstado = (estado) => {
  const s = estado === 'Aprobado' ? { background: '#e6f1fb', color: '#185FA5' } : { background: '#fff4e0', color: '#854F0B' };
  return <span style={{ ...s, padding: '2px 8px', borderRadius: '8px', fontSize: '11px', fontWeight: '600' }}>{estado}</span>;
};

export default function Gastos() {
  const isAdmin = useAdmin();
  const { accounts } = useMsal();
  const navigate = useNavigate();
  const registradoPor = accounts[0]?.name || accounts[0]?.username || null;

  const ahora = new Date();
  const [filtros, setFiltros] = useState({ anio: ahora.getFullYear(), mes: '', categoria_id: '', estado: '', estado_pago: '', q: '' });
  const [lista, setLista] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [catalogos, setCatalogos] = useState({ categorias: [], subcategorias: [], mediosPago: [], proyectos: [] });
  const [modal, setModal] = useState(false);
  const [editando, setEditando] = useState(null);
  const [detalle, setDetalle] = useState(null);

  useEffect(() => { cargarCatalogos(); }, []);
  useEffect(() => { cargar(); }, [filtros]);

  const cargarCatalogos = async () => {
    try {
      const [cat, sub, mp, proy] = await Promise.all([
        axios.get(`${API}/gastos-catalogos?tipo=categoria`),
        axios.get(`${API}/gastos-catalogos?tipo=subcategoria`),
        axios.get(`${API}/listas?lista=gasto_medio_pago`),
        axios.get(`${API}/proyectos`)
      ]);
      setCatalogos({
        categorias: (cat.data || []).filter(c => c.activo),
        subcategorias: (sub.data || []).filter(s => s.activo),
        mediosPago: mp.data || [],
        proyectos: proy.data || []
      });
    } catch (e) { console.error(e); }
  };

  const cargar = async () => {
    setCargando(true);
    try {
      const qs = new URLSearchParams();
      Object.entries(filtros).forEach(([k, v]) => { if (v !== '' && v != null) qs.append(k, v); });
      const r = await axios.get(`${API}/gastos?${qs.toString()}`);
      setLista(r.data || []);
    } catch (e) { console.error(e); }
    setCargando(false);
  };

  const kpis = {
    colones: lista.filter(g => g.moneda === 'Colones').reduce((a, g) => a + (g.monto_total || 0), 0),
    dolares: lista.filter(g => g.moneda === 'Dólares').reduce((a, g) => a + (g.monto_total || 0), 0),
    pendientes: lista.filter(g => g.estado === 'Registrado').length,
    sinMonto: lista.filter(g => g.sin_monto).length
  };

  const abrirNuevo = () => { setEditando(null); setModal(true); };
  const abrirEditar = (g) => { setEditando(g); setModal(true); setDetalle(null); };

  const aprobarUno = async (g) => {
    if (!window.confirm(`¿Aprobar el gasto de ${simbolo(g.moneda)}${fmt(g.monto_total)}?`)) return;
    try {
      await axios.post(`${API}/gastos?action=aprobar-masivo`, { ids: [g.id], aprobado_por: registradoPor });
      setDetalle(null); await cargar();
    } catch (e) { alert('Error: ' + (e.response?.data?.error || e.message)); }
  };

  const eliminar = async (g) => {
    if (!window.confirm('¿Eliminar este gasto permanentemente?')) return;
    try { await axios.delete(`${API}/gastos?id=${g.id}`); setDetalle(null); await cargar(); }
    catch (e) { alert('Error: ' + (e.response?.data?.error || e.message)); }
  };

  const aniosOpts = [];
  for (let y = ahora.getFullYear() + 1; y >= 2024; y--) aniosOpts.push(y);

  return (
    <div style={{ padding: '24px', fontFamily: 'Segoe UI, sans-serif', maxWidth: '1280px' }}>

      {/* Header */}
      <div style={{ background: '#012E40', borderRadius: '12px', padding: '16px 20px', marginBottom: '20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span style={{ color: '#fff', fontSize: '17px', fontWeight: '700' }}>Gastos operativos</span>
        <div style={{ display: 'flex', gap: '8px' }}>
          <button onClick={() => navigate('/app/gastos/recurrentes')} style={{ padding: '8px 14px', background: 'rgba(255,255,255,0.12)', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>Recurrentes</button>
          <button onClick={() => navigate('/app/gastos/aprobacion')} style={{ padding: '8px 14px', background: 'rgba(255,255,255,0.12)', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>Aprobacion</button>
          <button onClick={abrirNuevo} style={{ padding: '8px 16px', background: '#87B749', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>+ Nuevo gasto</button>
        </div>
      </div>

      {/* KPIs */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: '12px', marginBottom: '20px' }}>
        {[
          { label: 'Total Colones', valor: '₡' + fmt(kpis.colones), color: '#012E40' },
          { label: 'Total Dólares', valor: '$' + fmt(kpis.dolares), color: '#185FA5' },
          { label: 'Pendientes de aprobar', valor: kpis.pendientes, color: '#854F0B' },
          { label: 'Sin monto', valor: kpis.sinMonto, color: '#A32D2D' },
        ].map(s => (
          <div key={s.label} style={{ background: '#fff', border: '1px solid #e8e8e8', borderRadius: '10px', padding: '14px 18px' }}>
            <div style={{ fontSize: '11px', color: '#888', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{s.label}</div>
            <div style={{ fontSize: '22px', fontWeight: '700', color: s.color, marginTop: '4px' }}>{s.valor}</div>
          </div>
        ))}
      </div>

      {/* Filtros */}
      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginBottom: '16px', alignItems: 'center' }}>
        <select style={inputStyle} value={filtros.anio} onChange={e => setFiltros(f => ({ ...f, anio: e.target.value }))}>
          <option value="">Todos los años</option>
          {aniosOpts.map(y => <option key={y} value={y}>{y}</option>)}
        </select>
        <select style={inputStyle} value={filtros.mes} onChange={e => setFiltros(f => ({ ...f, mes: e.target.value }))}>
          <option value="">Todos los meses</option>
          {MESES.slice(1).map((m, i) => <option key={i + 1} value={i + 1}>{m}</option>)}
        </select>
        <select style={inputStyle} value={filtros.categoria_id} onChange={e => setFiltros(f => ({ ...f, categoria_id: e.target.value }))}>
          <option value="">Todas las categorias</option>
          {catalogos.categorias.map(c => <option key={c.id} value={c.id}>{c.nombre}</option>)}
        </select>
        <select style={inputStyle} value={filtros.estado} onChange={e => setFiltros(f => ({ ...f, estado: e.target.value }))}>
          <option value="">Todos los estados</option>
          <option value="Registrado">Registrado</option>
          <option value="Aprobado">Aprobado</option>
        </select>
        <select style={inputStyle} value={filtros.estado_pago} onChange={e => setFiltros(f => ({ ...f, estado_pago: e.target.value }))}>
          <option value="">Pago: todos</option>
          <option value="Pendiente">Pendiente</option>
          <option value="Pagado">Pagado</option>
        </select>
        <input style={{ ...inputStyle, flex: 1, minWidth: '160px' }} placeholder="Buscar descripcion/proveedor..." value={filtros.q} onChange={e => setFiltros(f => ({ ...f, q: e.target.value }))} />
      </div>

      {/* Tabla */}
      <div style={{ background: '#fff', border: '1px solid #e8e8e8', borderRadius: '12px', overflow: 'hidden' }}>
        {cargando ? (
          <div style={{ padding: '40px', textAlign: 'center', color: '#888' }}>Cargando...</div>
        ) : lista.length === 0 ? (
          <div style={{ padding: '40px', textAlign: 'center', color: '#bbb' }}>No hay gastos para los filtros seleccionados.</div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
            <thead>
              <tr style={{ background: '#f8f9fa' }}>
                {['Fecha', 'Categoria', 'Detalle', 'Proyecto', 'Empresa', 'Monto total', 'Pago', 'Estado'].map(h => (
                  <th key={h} style={{ padding: '11px 14px', textAlign: h === 'Monto total' ? 'right' : 'left', color: '#888', fontWeight: '600', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.5px', borderBottom: '1px solid #eee' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {lista.map(g => (
                <tr key={g.id} style={{ borderBottom: '1px solid #f3f3f3', cursor: 'pointer' }}
                  onClick={() => setDetalle(detalle?.id === g.id ? null : g)}
                  onMouseEnter={e => e.currentTarget.style.background = '#fafafa'}
                  onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                  <td style={{ padding: '10px 14px', color: '#555' }}>{formatFecha(g.fecha)}</td>
                  <td style={{ padding: '10px 14px', color: '#1a1a1a', fontWeight: '500' }}>
                    {g.categoria_nombre}{g.subcategoria_nombre ? <span style={{ color: '#999', fontWeight: '400' }}> · {g.subcategoria_nombre}</span> : null}
                  </td>
                  <td style={{ padding: '10px 14px', color: '#555' }}>{g.descripcion || g.proveedor || '—'}</td>
                  <td style={{ padding: '10px 14px', color: '#555' }}>{g.proyecto_codigo || <span style={{ color: '#bbb' }}>Operativo</span>}</td>
                  <td style={{ padding: '10px 14px', color: '#555' }}>{g.empresa}</td>
                  <td style={{ padding: '10px 14px', textAlign: 'right', fontWeight: '600', color: '#012E40' }}>
                    {g.sin_monto
                      ? <span style={{ background: '#FCEBEB', color: '#A32D2D', padding: '2px 8px', borderRadius: '8px', fontSize: '11px', fontWeight: '600' }}>Sin monto</span>
                      : `${simbolo(g.moneda)}${fmt(g.monto_total)}`}
                  </td>
                  <td style={{ padding: '10px 14px' }}>
                    <span style={{ fontSize: '11px', color: g.estado_pago === 'Pagado' ? '#3B6D11' : '#854F0B', fontWeight: '600' }}>{g.estado_pago}</span>
                  </td>
                  <td style={{ padding: '10px 14px' }}>{badgeEstado(g.estado)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* Panel detalle */}
      {detalle && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '20px' }}>
          <div style={{ background: '#fff', borderRadius: '16px', width: '100%', maxWidth: '680px', maxHeight: '90vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <div style={{ overflowY: 'auto', padding: '28px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '16px' }}>
                <div>
                  <div style={{ fontSize: '20px', fontWeight: '700', color: '#012E40', marginBottom: '6px' }}>
                    {detalle.sin_monto ? 'Sin monto' : `${simbolo(detalle.moneda)}${fmt(detalle.monto_total)}`}
                  </div>
                  <div style={{ display: 'flex', gap: '6px' }}>{badgeEstado(detalle.estado)}
                    <span style={{ background: '#f3f3f3', color: '#555', padding: '2px 8px', borderRadius: '8px', fontSize: '11px', fontWeight: '500' }}>{detalle.categoria_nombre}</span>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                  <button onClick={() => abrirEditar(detalle)} style={{ padding: '7px 16px', background: 'none', border: '1px solid #ddd', borderRadius: '8px', fontSize: '13px', cursor: 'pointer', color: '#555' }}>Editar</button>
                  {isAdmin && detalle.estado === 'Registrado' && !detalle.sin_monto && (
                    <button onClick={() => aprobarUno(detalle)} style={{ padding: '7px 16px', background: '#185FA5', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>Aprobar</button>
                  )}
                  {isAdmin && (
                    <button onClick={() => eliminar(detalle)} style={{ padding: '7px 16px', background: 'none', border: '1px solid #fcc', borderRadius: '8px', fontSize: '13px', cursor: 'pointer', color: '#A32D2D' }}>Eliminar</button>
                  )}
                  <button onClick={() => setDetalle(null)} style={{ background: 'none', border: 'none', fontSize: '22px', cursor: 'pointer', color: '#aaa', lineHeight: 1 }}>×</button>
                </div>
              </div>
              <hr style={{ border: 'none', borderTop: '1px solid #f0f0f0', margin: '14px 0' }} />
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '14px 24px' }}>
                {campoVer('Fecha', formatFecha(detalle.fecha))}
                {campoVer('Categoria', detalle.categoria_nombre)}
                {campoVer('Subcategoria', detalle.subcategoria_nombre)}
                {campoVer('Proyecto', detalle.proyecto_codigo ? `${detalle.proyecto_codigo} — ${detalle.proyecto_nombre || ''}` : 'Operativo (sin proyecto)')}
                {campoVer('Empresa', detalle.empresa)}
                {campoVer('Moneda', detalle.moneda)}
                {campoVer('Monto sin IVA', detalle.sin_monto ? '—' : fmt(detalle.monto_sin_iva))}
                {campoVer('IVA (' + (detalle.tasa_iva ?? 0) + '%)', detalle.sin_monto ? '—' : fmt(detalle.monto_iva))}
                {campoVer('Monto total', detalle.sin_monto ? '—' : fmt(detalle.monto_total))}
                {campoVer('Proveedor', detalle.proveedor)}
                {campoVer('Comprobante', detalle.tipo_comprobante ? `${detalle.tipo_comprobante} ${detalle.numero_comprobante || ''}` : null)}
                {campoVer('Medio de pago', detalle.medio_pago_nombre)}
                {campoVer('Estado de pago', detalle.estado_pago)}
                {campoVer('Fecha de pago', detalle.fecha_pago ? formatFecha(detalle.fecha_pago) : null)}
                {campoVer('Registrado por', detalle.registrado_por)}
                {detalle.estado === 'Aprobado' && campoVer('Aprobado por', detalle.aprobado_por)}
                {detalle.recurrente_id && campoVer('Origen', 'Recurrente')}
              </div>
              {detalle.notas && (<><hr style={{ border: 'none', borderTop: '1px solid #f0f0f0', margin: '14px 0' }} />{campoVer('Notas', detalle.notas)}</>)}
            </div>
          </div>
        </div>
      )}

      {modal && (
        <ModalGasto
          editando={editando}
          catalogos={catalogos}
          registradoPor={registradoPor}
          onClose={() => setModal(false)}
          onSaved={cargar}
        />
      )}
    </div>
  );
}
